import { LOADING_TYPES } from '@/shared/config';
import { useReportStore } from '@/entities/report';
import { useLoadingStore } from '@/shared/lib/loadingStore';

/**
 * Derives which PDF report loading overlay should be shown. Reads the loading text and the report record from the stores, flags a clinic report when the status is Rendering with background rendering on, and flags the stopping-AI state from the loading text.
 *
 * @returns An object carrying isClinicReport and isStoppingAiProcess.
 */
const usePdfReportLoadingOverlay = () => {
  const loadingText = useLoadingStore((s) => s.loading?.loadingText);
  const report = useReportStore((s) => s.reportData)?.report || {};
  const { isRenderingBackground, status: reportStatus } = report;
  const isRendering = reportStatus === 'Rendering';
  const isClinicReport = isRendering && isRenderingBackground === true;

  const isStoppingAiProcess = loadingText === LOADING_TYPES.STOPPING_AI_PROCESS;

  return { isClinicReport, isStoppingAiProcess };
};

export default usePdfReportLoadingOverlay;
